import styled, { css } from 'styled-components';
import { IconButton } from '@material-ui/core';

export default {
  ActionsWrapper: styled.div``,

  ActionItem: styled(IconButton)`
    transition: all 0.15s;

    ${({ $active, theme }) =>
      $active &&
      css`
        color: ${theme.palette.primary.light};
      `}
    ${({ $hide }) =>
      $hide &&
      css`
        display: none;
      `}
  `,
};
